import React from 'react';

import { formatFigure, formatSeparateByThousands } from 'Helpers/formatService';

import Button from 'CommonComponents/Button';

import ArrowLeftIcon from 'Assets/icons/arrow-left.svg';
import ArrowRightIcon from 'Assets/icons/arrow-right.svg';
import CircleCheckIcon from 'Assets/icons/circle-check.svg';

const isRtl = () => typeof document !== 'undefined' && document.documentElement.dir === 'rtl';

/**
 * A budget change in Home's unified approvals queue.
 *
 * WHY THIS EXISTS AND THE OTHER FOUR TYPES REUSE THEIR ROW.
 * A budget change carries nine cells' worth of detail — budget action, date,
 * location, total, pending/approved split, model action, status and stage —
 * which cannot be fitted into the queue's five columns by any arrangement of
 * optional props. The four procurement and fund types render five, so those
 * rows are reused as they are.
 *
 * A PENDING ROW OFFERS Action, LIKE EVERY OTHER TYPE. The deep link is what a
 * row this user cannot action falls back to — a decision already taken, or an
 * item the server marks non-inline. `can_act_inline` says which from the server;
 * this row never infers it.
 *
 * `row` is a `BudgetChangesApprovableRequestResource` payload; the fields below
 * mean what that resource defines them to mean.
 */
export default function UserApprovalListBudgetChangesApprovalsCompactRow(props) {
    const ArrowIcon = isRtl() ? ArrowLeftIcon : ArrowRightIcon;

    return (
        <tr className={props.rowClassName}>
            <td onClick={props.onClickHandler} className="tw-cursor-pointer inbud-date-cell">
                {props.waitingLabel}
            </td>
            <td onClick={props.onClickHandler} className="tw-cursor-pointer">
                {props.typeLabel}
            </td>
            <td onClick={props.onClickHandler} className="tw-cursor-pointer">
                {props.row.location_type}: {props.row.parent?.name || ''}
                <span className="tw-block tw-text-2xs tw-text-charcoal-60">
                    {props.row.budget_action} · {props.row.model_action} {props.row.model_type_name}
                </span>
                {props.titleSubLine}
            </td>
            <td onClick={props.onClickHandler} className="tw-cursor-pointer inbud-numeric-cell">
                {formatFigure(props.row.total_amount, formatSeparateByThousands, { precision: 3 })}
            </td>
            {!!props.outcomeChip && <td>{props.outcomeChip}</td>}
            <td>
                {props.canBeToggled && props.isPending() ? (
                    <small className="pl-3">
                        <Button variant="success" onClick={props.toggle}>
                            <CircleCheckIcon className="tw-w-3 tw-h-3 tw-mr-1" aria-hidden="true" />
                            {$t('Action')}
                        </Button>
                    </small>
                ) : (
                    /* stopPropagation: this cell's own onClick, not the row's —
                       the link navigates away immediately, so it must not also
                       open the pop-up first. */
                    <a
                        href={props.href}
                        onClick={(e) => e.stopPropagation()}
                        className="tw-inline-flex tw-items-center tw-gap-x-1 tw-text-xs tw-font-semibold tw-text-blue tw-no-underline"
                    >
                        {$t('Review in Budget')}
                        <ArrowIcon className="tw-w-3 tw-h-3" />
                    </a>
                )}
            </td>
        </tr>
    );
}
